import React, { useMemo, useCallback, useEffect, useState } from "react";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { generateColumns } from "../../../custom/Utils/ColumnUtils";
import useFetchData from "../../../custom/Utils/UseFetchDataUtils";
import usePagination from "../../../custom/Utils/UsePaginationUtils";
import { listPageData, exportPageData } from "./GSTPercentageFile";
import { getRecords } from "../../../services/api.service";

const GSTPercentageList = () => {
  const navigate = useNavigate();
  const {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  } = listPageData();
  const initialPayload = useMemo(() => payload, []);

  // pagination
  const {
    page,
    pageSize,
    nextPage,
    previousPage,
    lastPage,
    firstPage,
    handlePageSizeChange,
    setPage,
  } = usePagination();

  // fetch data using the provided payload, page, and page size
  const { data, isLoading, setSearchKeyword, totalCount } = useFetchData(
    initialPayload,
    page,
    pageSize,
    endpoint,
    searchfields
  );
  const [dataForExport, setDataForExport] = useState([]);

  // handle create action
  const handleCreate = () => navigate(navigatePage.create);

  // handle edit action
  const handleEdit = useCallback(
    (id) => {
      navigate(navigatePage.edit + "/" + id);
    },
    [navigate, navigatePage.edit]
  );

  // columns data
  const columns = useMemo(
    () => generateColumns(data, columnData, handleEdit, page, pageSize),
    [data, columnData, handleEdit, page, pageSize]
  );

  // handle page size change callback
  const handlePageSizeChangeWrapper = useCallback(
    (newSize) => {
      if (newSize !== pageSize) {
        handlePageSizeChange(newSize, totalCount);
        setPage(0); // Reset to first page when page size changes
      }
    },
    [handlePageSizeChange, pageSize, totalCount, setPage]
  );
  useEffect(() => {
    const handleExportData = async () => {
      try {
        const responseData = await getRecords(exportPageData, endpoint);
        console.log("responseData", responseData.data);
        setDataForExport(responseData.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    handleExportData();
  }, []);

  const exportData = dataForExport?.map((item, index) => ({
    "Sr. No": index + 1,
    "GST PERCENTAGE": item?.gst_percentage || "N/A",
    "CREATED BY": item?.createdBy?.first_name || "N/A",
    STATUS:
      item?.is_active === "Active" ||
      item?.is_active === false ||
      item?.is_active === 0
        ? "In-active"
        : "Active",
  }));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumbs title={headerName + " List"} breadcrumbItems={[]} />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleCreate}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create {headerName}
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isLoading={isLoading}
                onSearchInputData={setSearchKeyword}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChangeWrapper}
                nextToPage={nextPage}
                lastToPage={() => lastPage(totalCount)}
                previousToPage={previousPage}
                previousFirstToPage={firstPage}
                totalCount={totalCount}
                customPageSize={pageSize}
                exportData={exportData}
                exportFileName={exportFileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GSTPercentageList;
